/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { useDocumentTitle } from '../../../../utils/useDocumentTitle';
import { useGetStartedStyles } from './GetStarted.styles';

type GetStartedProps = {
  goToNextStep: () => void;
};

export const GetStarted = memo<GetStartedProps>(props => {
  const { t } = useTranslation(Namespaces.Setup);
  useDocumentTitle(t('page.title'));
  const classes = useGetStartedStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h1">{t('page.get_started.greeting')}</Typography>
      <Typography component="div" variant="body1" classes={{ root: classes.info }}>
        {t('page.get_started.info')}
      </Typography>
      <div className={classes.buttons}>
        <Button
          data-cy="setup-get-started"
          onClick={props.goToNextStep}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
        >
          {t('page.buttons.get_started')}
        </Button>
      </div>
    </div>
  );
});
